import { DefaultTheme } from "styled-components";

export type PillStatus = "ERROR" | "SUCCESS" | "WARNING" | "INFO";

export const statusPillColors: {
  [key in PillStatus]: {
    color: keyof DefaultTheme["status"];
    bgColor: keyof DefaultTheme["status"];

    // TODO: POPRAWIĆ ZANIM AGNIESZKA ZOBACZY
  };
} = {
  ERROR: {
    color: "errorHighestContrast",
    bgColor: "errorLowestContrast",
  },
  SUCCESS: {
    color: "successHighestContrast",
    bgColor: "successLowestContrast",
  },
  WARNING: {
    color: "warningHighestContrast",
    bgColor: "warningMediumContrast",
  },
  INFO: {
    color: "infoHighestContrast",
    bgColor: "infoLowestContrast",
  },
};
